/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CommunicationChannelEnum = {
    Email: 'EMAIL',
    Sms: 'SMS',
    Phone: 'PHONE',
    Letter: 'LETTER',
    Note: 'NOTE',
    Other: 'OTHER',
    Chat: 'CHAT'
} as const;
export type CommunicationChannelEnum = typeof CommunicationChannelEnum[keyof typeof CommunicationChannelEnum];

